"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var listBox = _7a468({
  defaultClassName: "Combobox_listBox__ho1oxd0",
  variantClassNames: {
    status: {
      entering: "Combobox_listBox_status_entering__ho1oxd1",
      entered: "Combobox_listBox_status_entered__ho1oxd2",
      exiting: "Combobox_listBox_status_exiting__ho1oxd3",
      exited: "Combobox_listBox_status_exited__ho1oxd4",
      unmounted: "Combobox_listBox_status_unmounted__ho1oxd5"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var loader = "Combobox_loader__ho1oxd6";
export var loaderSpinner = "Combobox_loaderSpinner__ho1oxd7";
export var option = "Combobox_option__ho1oxd8";